import { BRANCH_TYPE, FORM_CONSTANTS, INSTALLER_ENTRIES, TENANT_ID } from 'global/constants';

import {
  doesRegisteredInstallerHaveBranch,
  isInstallerRegisteringForBranch,
  isRegisteredBranchGuest,
  isRegisteredInstallerOnlyMain,
  isRegisteringBranchGuest,
  isRegisteringInstallerGuestOnly,
  isRegisteringInstallerOnlyMain,
} from 'utils/InstallerUtils';
import { getTenantId } from 'utils/tenantUtil';

export const VALIDATION_CONDITIONS = {
  CONDITION: 'condition',
  AND: 'and',
  OR: 'or',
  NOT: 'not',
  VALUE: 'value',
};

export const onlyHilfsbetrieb = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) => validationConfig.isOnlyHilfsbetrieb === true,
};

export const onlyNE = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) => validationConfig.form === FORM_CONSTANTS.NE,
};
export const onlyDEB = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) => validationConfig.form === FORM_CONSTANTS.DEB,
};
export const never = {
  type: VALIDATION_CONDITIONS.VALUE,
  evaluate: () => false,
};
export const always = {
  type: VALIDATION_CONDITIONS.VALUE,
  evaluate: () => true,
};

export const mobileOrPhoneOptional = (fieldName) => ({
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) => {
    const values = validationConfig.values || {};
    const mobileValue = values.mobile;
    const phoneValue = values.phone;

    if (fieldName === 'mobile') {
      return !!phoneValue;
    }
    if (fieldName === 'phone') {
      return !!mobileValue;
    }

    return false;
  },
});

export const onlyBAG = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: () => getTenantId() === TENANT_ID.BAG,
};
export const onlyLVN = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: () => getTenantId() === TENANT_ID.LVN,
};
export const onlyAVA = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: () => getTenantId() === TENANT_ID.AVA,
};

export const onlyGuestNE = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    isRegisteringInstallerGuestOnly(validationConfig.branchSelectionValues),
};
export const onlyGuestDEB = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    validationConfig.installerStatusSummary.installerEntry === INSTALLER_ENTRIES.GUEST_ONLY,
};
export const onlyMainDEB = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    isRegisteredInstallerOnlyMain(validationConfig.installerStatusSummary),
};
export const MainDEB = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    (doesRegisteredInstallerHaveBranch(
      BRANCH_TYPE.ENERGY,
      validationConfig.installerStatusSummary
    ) &&
      !isRegisteredBranchGuest(validationConfig.installerStatusSummary, BRANCH_TYPE.ENERGY)) ||
    (doesRegisteredInstallerHaveBranch(BRANCH_TYPE.GAS, validationConfig.installerStatusSummary) &&
      !isRegisteredBranchGuest(validationConfig.installerStatusSummary, BRANCH_TYPE.GAS)),
};
export const onlyMainNE = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    isRegisteringInstallerOnlyMain(validationConfig.branchSelectionValues),
};

export const MainNE = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    (isInstallerRegisteringForBranch(BRANCH_TYPE.ENERGY, validationConfig.branchSelectionValues) &&
      !isRegisteringBranchGuest(BRANCH_TYPE.ENERGY, validationConfig.branchSelectionValues)) ||
    (isInstallerRegisteringForBranch(BRANCH_TYPE.GAS, validationConfig.branchSelectionValues) &&
      !isRegisteringBranchGuest(BRANCH_TYPE.GAS, validationConfig.branchSelectionValues)),
};
export const isRegisteredInstallerGasGuest = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    doesRegisteredInstallerHaveBranch(BRANCH_TYPE.GAS, validationConfig.installerStatusSummary) &&
    isRegisteredBranchGuest(validationConfig.installerStatusSummary, BRANCH_TYPE.GAS),
};
export const isRegisteredInstallerEnergyGuest = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    doesRegisteredInstallerHaveBranch(
      BRANCH_TYPE.ENERGY,
      validationConfig.installerStatusSummary
    ) && isRegisteredBranchGuest(validationConfig.installerStatusSummary, BRANCH_TYPE.ENERGY),
};

export const isRegisteringInstallerGasGuest = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    isInstallerRegisteringForBranch(BRANCH_TYPE.GAS, validationConfig.branchSelectionValues) &&
    isRegisteringBranchGuest(BRANCH_TYPE.GAS, validationConfig.branchSelectionValues),
};
export const isRegisteringInstallerEnergyGuest = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    isInstallerRegisteringForBranch(BRANCH_TYPE.ENERGY, validationConfig.branchSelectionValues) &&
    isRegisteringBranchGuest(BRANCH_TYPE.ENERGY, validationConfig.branchSelectionValues),
};
export const isRegisteringExpertOwner = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) => validationConfig.expert.isExpertOwner,
};
export const onlyEnergy = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) => validationConfig.branch === BRANCH_TYPE.ENERGY,
};
export const onlyGas = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) => validationConfig.branch === BRANCH_TYPE.GAS,
};
export const masterTo1997Energy = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    validationConfig.firstQualificationEnergy === 'masterTo1997Energy',
};
export const masterFrom1998To2003Energy = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    validationConfig.firstQualificationEnergy === 'masterFrom1998To2003Energy',
};
export const masterFrom2004Energy = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    validationConfig.firstQualificationEnergy === 'masterFrom2004Energy',
};
export const masterTo1997Gas = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) => validationConfig.firstQualificationGas === 'masterTo1997Gas',
};
export const masterFrom1998To2003Gas = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    validationConfig.firstQualificationGas === 'masterFrom1998To2003Gas',
};
export const masterFrom2004Gas = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) => validationConfig.firstQualificationGas === 'masterFrom2004Gas',
};
export const technicalHighSchool = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) => validationConfig.firstQualificationGas === 'technicalHighSchool',
};
export const engineer = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) => validationConfig.firstQualificationGas === 'engineer',
};
export const otherQualificationEnergy = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    validationConfig.firstQualificationEnergy === 'otherQualificationEnergy',
};

export const otherQualificationGas = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) =>
    validationConfig.firstQualificationGas === 'otherQualificationGas',
};

export const expertNotOwner = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) => validationConfig.expert.isExpertOwner !== true,
};
export const handleDEBDocumentsRendering = (triggers, notTriggers) => ({
  type: VALIDATION_CONDITIONS.AND,
  conditions: [
    {
      type: VALIDATION_CONDITIONS.NOT,
      condition: {
        type: VALIDATION_CONDITIONS.CONDITION,
        evaluate: (validationConfig) =>
          validationConfig.triggers.some((trigger) => notTriggers.includes(trigger)),
      },
    },
    {
      type: triggers.length >= 1 ? VALIDATION_CONDITIONS.CONDITION : VALIDATION_CONDITIONS.VALUE,
      evaluate: (validationConfig) =>
        triggers.length >= 1
          ? validationConfig.triggers.some((trigger) => triggers.includes(trigger))
          : true,
    },
  ],
});
export const handleFieldRendering = (triggers, notTriggers) => ({
  type: VALIDATION_CONDITIONS.AND,
  conditions: [
    {
      type: VALIDATION_CONDITIONS.NOT,
      condition: {
        type: VALIDATION_CONDITIONS.CONDITION,
        evaluate: (validationConfig) =>
          validationConfig.expertQualificationsTriggers.some((trigger) =>
            notTriggers.includes(trigger)
          ),
      },
    },
    {
      type: triggers.length >= 1 ? VALIDATION_CONDITIONS.CONDITION : VALIDATION_CONDITIONS.VALUE,
      evaluate: (validationConfig) =>
        triggers.length >= 1
          ? validationConfig.expertQualificationsTriggers.some((trigger) =>
              triggers.includes(trigger)
            )
          : true,
    },
  ],
});

export const isGermanyCountry = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) => validationConfig?.values?.companyCountry === 'DE',
};
export const isLokaRefEnabled = {
  type: VALIDATION_CONDITIONS.CONDITION,
  evaluate: (validationConfig) => ![].includes(getTenantId()),
};
